import { createContext, useContext } from 'react'

export const EChartsColorSchemeContext = createContext(null)
export const useEChartsColorScheme = () => useContext(EChartsColorSchemeContext)
